export default [
  {
    name: "environmentMapTexture",
    type: "cubeTexture",
    path: [
      "/envMap/px.png",
      "/envMap/nx.png",
      "/envMap/py.png",
      "/envMap/ny.png",
      "/envMap/pz.png",
      "/envMap/nz.png",
    ],
  },
  {
    name: "moonModel",
    type: "gltfModel",
    path: "/models/moon.glb",
  },
  {
    name: "planetModel",
    type: "gltfModel",
    path: "/models/planet.glb",
  },
  {
    name: "planetMatcapTexture",
    type: "texture",
    path: "/textures/8194AB_D6DFEB_C0CEDE_B0BFD1-512px.png",
  },
  {
    name: "planetLandMatcapTexture",
    type: "texture",
    path: "/textures/D8D8E5_9D9DAF_B4B4C4_B4B4CC-512px.png",
  },
  {
    name: "moonMatcapTexture",
    type: "texture",
    path: "/textures/C8AF84_F9ECD7_EFDEBF_E6D1AF-512px.png",
  },
  {
    name: "astronautModel",
    type: "gltfModel",
    path: "/models/astronaut.glb",
  },
  {
    name: "astronautBodyMatcapTexture",
    type: "texture",
    path: "/textures/EAEAEA_B5B5B5_CCCCCC_D4D4D4-512px.png",
  },
  {
    name: "astronautTrimMatcapTexture",
    type: "texture",
    path: "/textures/7A7A7A_D0D0D0_BCBCBC_B4B4B4-512px.png",
  },
  {
    name: "astronautRedMatcapTexture",
    type: "texture",
    path: "/textures/C75F55_F8BDA9_EB9484_F4A494-512px.png",
  },
  {
    name: "astronautBlueLightMatcapTexture",
    type: "texture",
    path: "/textures/C4DEDE_97B5B5_EAF9F9_ABC4C4-512px.png",
  },
  {
    name: "soccerBallModel",
    type: "gltfModel",
    path: "/models/soccer.glb",
  },
  {
    name: "soccerBlackMatcapTexture",
    type: "texture",
    path: "/textures/5F5F5F_BDBDBD_A4A4A4_9C9C9C-512px.png",
  },
  {
    name: "soccerGoalModel",
    type: "gltfModel",
    path: "/models/soccerGoal.glb",
  },
  {
    name: "soccerNetMap",
    type: "texture",
    path: "/alphaMap/netAlpha.jpeg",
  },
  {
    name: "soccerNetSidesMap",
    type: "texture",
    path: "/alphaMap/netAlpha.jpeg",
  },
  {
    name: "grassModel",
    type: "gltfModel",
    path: "/models/grass.glb",
  },
  {
    name: "grassMatcapTexture",
    type: "texture",
    path: "/textures/5ECBA4_BCFAE7_92EED0_A1F4DC-512px.png",
  },
  {
    name: "woodMatcapTexture",
    type: "texture",
    path: "/textures/AC8961_EBDAC3_D1B791_DCC2A0-64px.png",
  },
  {
    name: "treeModel",
    type: "gltfModel",
    path: "/models/tree.glb",
  },
  {
    name: "treeMatcapTexture",
    type: "texture",
    path: "/textures/6BBD6B_C8F3C8_A3E2A3_B4ECB4-512px.png",
  },
  {
    name: "tableModel",
    type: "gltfModel",
    path: "/models/table.glb",
  },
  {
    name: "tableTopMatcapTexture",
    type: "texture",
    path: "/textures/5F5F5F_BDBDBD_A4A4A4_9C9C9C-512px-dark.png",
  },
  {
    name: "tableDrawerMatcapTexture",
    type: "texture",
    path: "/textures/EAEAEA_B5B5B5_CCCCCC_D4D4D4-512px.png",
  },
  {
    name: "monitorScreenTexture",
    type: "texture",
    path: "/textures/Pics/monitorScreen.png",
  },
  {
    name: "laptopModel",
    type: "gltfModel",
    path: "/models/laptop.glb",
  },
  {
    name: "laptopScreenTexture",
    type: "texture",
    path: "/textures/Pics/ChromaBlue.png",
  },
  {
    name: "chairModel",
    type: "gltfModel",
    path: "/models/chair.glb",
  },
  {
    name: "speakerModel",
    type: "gltfModel",
    path: "/models/speaker.glb",
  },
  {
    name: "picFrameModel",
    type: "gltfModel",
    path: "/models/picFrame.glb",
  },
  {
    name: "picTexture",
    type: "texture",
    path: "/textures/Pics/IMG_0952.JPG",
  },
  {
    name: "mugModel",
    type: "gltfModel",
    path: "/models/mug.glb",
  },
  {
    name: "mugMatcapTexture",
    type: "texture",
    path: "/textures/7A7A7A_D0D0D0_BCBCBC_B4B4B4-512px.png",
  },
  {
    name: "telescopeModel",
    type: "gltfModel",
    path: "/models/telescope.glb",
  },
  {
    name: "darkMatcapTexture",
    type: "texture",
    path: "/textures/0F0F0F_4B4B4B_1C1C1C_2C2C2C-512px.png",
  },
  {
    name: "sofaModel",
    type: "gltfModel",
    path: "/models/sofa.glb",
  },
  {
    name: "sofaPillowModel",
    type: "gltfModel",
    path: "/models/sofaPillow.glb",
  },
  {
    name: "sofaMatcapTexture",
    type: "texture",
    path: "/textures/C7B9A1_F8F1E4_EEE4D2_E4D8C4-512px.png",
  },
  {
    name: "sofaPillowMatcapTexture",
    type: "texture",
    path: "/textures/CB919B_F9DDE1_ECC0C8_F4CCD4-512px.png",
  },
  {
    name: "tvBenchModel",
    type: "gltfModel",
    path: "/models/tvBench.glb",
  },
  {
    name: "tvModel",
    type: "gltfModel",
    path: "/models/tv.glb",
  },
  {
    name: "switchModel",
    type: "gltfModel",
    path: "/models/switch.glb",
  },
  {
    name: "switchBlueMatcapTexture",
    type: "texture",
    path: "/textures/65A0C7_C3E4F8_A7D5EF_97CAE9-512px.png",
  },
  {
    name: "switchRedMatcapTexture",
    type: "texture",
    path: "/textures/DC3E04_B52604_FC7D20_F85F04-512px.png",
  },
  {
    name: "diffuserModel",
    type: "gltfModel",
    path: "/models/diffuser.glb",
  },
  {
    name: "logoBaseModel",
    type: "gltfModel",
    path: "/models/logoBase.glb",
  },
  {
    name: "logoTopModel",
    type: "gltfModel",
    path: "/models/logoTop.glb",
  },
  {
    name: "logoBottomModel",
    type: "gltfModel",
    path: "/models/logoBottom.glb",
  },
  {
    name: "logoTextModel",
    type: "gltfModel",
    path: "/models/logoText.glb",
  },
  {
    name: "twitterIconModel",
    type: "gltfModel",
    path: "/models/twitterIcon.glb",
  },
  {
    name: "githubIconModel",
    type: "gltfModel",
    path: "/models/githubIcon.glb",
  },
  {
    name: "linkedinIconModel",
    type: "gltfModel",
    path: "/models/linkedinIcon.glb",
  },
  {
    name: "emailIconModel",
    type: "gltfModel",
    path: "/models/emailIcon.glb",
  },
  {
    name: "logoMatcapTexture",
    type: "texture",
    path: "/textures/7877EE_D87FC5_75D9C7_1C78C0-512px.png",
  },
  {
    name: "moonRoverModel",
    type: "gltfModel",
    path: "/models/moonRover.glb",
  },
  {
    name: "moonRoverSilverMatcapTexture",
    type: "texture",
    path: "/textures/C7C7D7_4C4E5A_818393_6C6C74-512px.png",
  },
  {
    name: "moonRoverCopperMatcapTexture",
    type: "texture",
    path: "/textures/EA783E_6D4830_905837_FCDC6C-512px.png",
  },
  {
    name: "moonRoverRedMatcapTexture",
    type: "texture",
    path: "/textures/C30C0C_9F0404_830404_5C0404-512px.png",
  },
  {
    name: "moonRoverWheelsModel",
    type: "gltfModel",
    path: "/models/moonRoverWheels.glb",
  },
  {
    name: "moonLanderModel",
    type: "gltfModel",
    path: "/models/moonLander.glb",
  },
  {
    name: "moonSatelliteModel",
    type: "gltfModel",
    path: "/models/moonSatellite.glb",
  },
  {
    name: "moonSatelliteYellowMatcapTexture",
    type: "texture",
    path: "/textures/855D08_DAC31B_BF9B0C_AF860C-512px.png",
  },
  {
    name: "shelfModel",
    type: "gltfModel",
    path: "/models/shelf.glb",
  },
  {
    name: "project001Model",
    type: "gltfModel",
    path: "/models/project001.glb",
  },
  {
    name: "project002Model",
    type: "gltfModel",
    path: "/models/project002.glb",
  },
  {
    name: "project003Model",
    type: "gltfModel",
    path: "/models/project003.glb",
  },
  {
    name: "project004Model",
    type: "gltfModel",
    path: "/models/project004.glb",
  },
  {
    name: "project001Texture",
    type: "texture",
    path: "/textures/Pics/SpaceTourism.png",
  },
  {
    name: "project002Texture",
    type: "texture",
    path: "/textures/Pics/MiniCyberpunk.png",
  },
  {
    name: "project003Texture",
    type: "texture",
    path: "/textures/Pics/Sci-FiCorridor.png",
  },
  {
    name: "project004Texture",
    type: "texture",
    path: "/textures/Pics/TikiShaman.png",
  },
  {
    name: "legoModel",
    type: "gltfModel",
    path: "/models/lego.glb",
  },
  {
    name: "legoDarkBlueMatcapTexture",
    type: "texture",
    path: "/textures/304FB1_69A1EF_5081DF_5C8CE6-512px.png",
  },
  {
    name: "legoRedMatcapTexture",
    type: "texture",
    path: "/textures/CB4934_FB9971_F07554_F68464-512px.png",
  },
  {
    name: "ufoModel",
    type: "gltfModel",
    path: "/models/ufo.glb",
  },
  {
    name: "ufoGrayMatcapTexture",
    type: "texture",
    path: "/textures/B0A2A8_866A63_E8E9F2_614C4F-512px.png",
  },
  {
    name: "ufoWhiteMatcapTexture",
    type: "texture",
    path: "/textures/D8D8E5_9D9DAF_B4B4C4_B4B4CC-512px.png",
  },
  {
    name: "ufoBlackMatcapTexture",
    type: "texture",
    path: "/textures/7A7A7A_D0D0D0_BCBCBC_B4B4B4-512px.png",
  },
  {
    name: "ufoBlueMatcapTexture",
    type: "texture",
    path: "/textures/3E95CC_65D9F1_A2E2F6_679BD4-512px.png",
  },
  {
    name: "miniPlanetModel",
    type: "gltfModel",
    path: "/models/miniPlanet.glb",
  },
  {
    name: "miniPlanetMatcapTexture001",
    type: "texture",
    path: "/textures/miniPlanetTexture/7B5254_E9DCC7_B19986_C8AC91-512px.png",
  },
  {
    name: "miniPlanetMatcapTexture002",
    type: "texture",
    path: "/textures/miniPlanetTexture/495CA6_CCD2E6_A5B1D8_1E2852-512px.png",
  },
  {
    name: "miniPlanetMatcapTexture003",
    type: "texture",
    path: "/textures/miniPlanetTexture/C09E5C_DAD2B9_654429_81582D-512px.png",
  },
  {
    name: "miniPlanetMatcapTexture004",
    type: "texture",
    path: "/textures/miniPlanetTexture/FBB43F_FBE993_FB552E_FCDD65-512px.png",
  },
  {
    name: "miniPlanetMatcapTexture005",
    type: "texture",
    path: "/textures/miniPlanetTexture/3F3D52_CCCED9_AFB0C6_8D8CAC-512px.png",
  },
  {
    name: "miniPlanetMatcapTexture006",
    type: "texture",
    path: "/textures/miniPlanetTexture/7DA1BA_A4CCE8_5D7A8B_5E7C94-512px.png",
  },
  {
    name: "miniPlanetMatcapTexture007",
    type: "texture",
    path: "/textures/miniPlanetTexture/9C5B3B_49200A_E9C8AB_DDAB7D-512px.png",
  },
  {
    name: "miniPlanetMatcapTexture008",
    type: "texture",
    path: "/textures/miniPlanetTexture/85B9D3_C9EAF9_417277_528789-512px.png",
  },
  {
    name: "miniPlanetMatcapTexture009",
    type: "texture",
    path: "/textures/miniPlanetTexture/773012_AE5124_4D1908_340F04-512px.png",
  },
  {
    name: "miniPlanetMatcapTexture010",
    type: "texture",
    path: "/textures/miniPlanetTexture/ED4630_791A0E_A42716_501009-512px.png",
  },
  {
    name: "miniPlanetMatcapTexture011",
    type: "texture",
    path: "/textures/miniPlanetTexture/C2A584_363B41_71665B_8C7367-512px.png",
  },
  {
    name: "miniPlanetMatcapTexture012",
    type: "texture",
    path: "/textures/miniPlanetTexture/D0CCCB_524D50_928891_727581-512px.png",
  },
  {
    name: "indicatorModel",
    type: "gltfModel",
    path: "/models/indicator.glb",
  },
  {
    name: "shadowMap",
    type: "texture",
    path: "/alphaMap/simpleShadow.jpeg",
  },
  {
    name: "helpPageTexture",
    type: "texture",
    path: "/textures/HelpPage.png",
  },
  {
    name: "boarderMap",
    type: "texture",
    path: "/alphaMap/netAlpha.jpeg",
  },
];
